import { render } from "./AccountPage.vue?vue&type=template&id=0e850305"
import script from "./AccountPage.vue?vue&type=script&lang=js"
export * from "./AccountPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__